export default {
      id: "attachment-usage",
      viewBox: "0 0 15 15",
      url: "/assets/" + "icons.svg#attachment",
      toString: function () {
        return this.url;
      }
    }